<template>
  <div class="manage-content">
    <div class="location">达人管理中心 / 我的余额</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <detailed></detailed>
    </div>
  </div>
</template>
<script>
import Detailed from './components/Detailed'
export default {
  name: 'EnterpriseBalance',
  components: {
    Detailed
  }
}
</script>
<style scoped></style>
